import { getMapIcons } from '../../data/icons/mapIcons.js';
import getImageId from './imageIds.js';
import { DEFAULT_ICON_SCALE } from './mapConstants.js';

const widthRegex = /width="(\d+)(px)?"/;
const heightRegex = /height="(\d+)(px)?"/;
const svgCache = {};


const ITEMS_TO_KEEP_IN_MISCELLANEOUS = [
    
    
];


export function scaleSvgIcon(svg, scale) {
    if (!svg) return '';
    try {
        const numericScale = parseFloat(scale);
        if (isNaN(numericScale)) {
            console.warn(`Invalid scale value for SVG: ${scale}. Using default size.`);
            return svg.replace(widthRegex, `width="${DEFAULT_ICON_SCALE}"`).replace(heightRegex, `height="${DEFAULT_ICON_SCALE}"`);
        }
        return svg.replace(widthRegex, `width="${numericScale}"`).replace(heightRegex, `height="${numericScale}"`);
    } catch (e) {
        console.error("Error scaling SVG:", e);
        return `<svg width="${scale}" height="${scale}" viewBox="0 0 10 10"><circle cx="5" cy="5" r="4" fill="grey"/></svg>`;
    }
}

// Generates or retrieves a cached SVG string for a given icon identifier, scaled to the specified size.
export function generateSvgString(iconKeyOrId, scale = DEFAULT_ICON_SCALE) {
    const cacheKey = `${iconKeyOrId}_${scale}`;
    if (svgCache[cacheKey]) {
        return svgCache[cacheKey];
    }
    let svgString;
    const imageId = getImageId(iconKeyOrId);
    const allIcons = getMapIcons();
    const iconData = allIcons[imageId] || allIcons['misc'];
    if (!iconData || typeof iconData !== 'string') {
        console.warn(`Icon data for '${imageId}' (from '${iconKeyOrId}') not found or invalid. Using fallback SVG.`);
        svgString = `<svg width="${scale}" height="${scale}" viewBox="0 0 10 10"><circle cx="5" cy="5" r="4" fill="purple"/></svg>`;
    } else {
        svgString = scaleSvgIcon(iconData, scale);
    }
    svgCache[cacheKey] = svgString;
    return svgString;
}

// Initializes a nested object structure based on provided patterns.
export const initializeIconsStructure = (patterns) => {
    const result = {};
    for (const [key, value] of Object.entries(patterns)) {
        if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
            result[key] = initializeIconsStructure(value);
        } else {
            result[key] = [];
        }
    }
    return result;
};


const matchPattern = (patternsInput, text) => {
    if (!patternsInput || typeof text !== 'string') {
        return false;
    }

    const patternsToTest = Array.isArray(patternsInput) ? patternsInput : [patternsInput];

    for (const pattern of patternsToTest) {
        if (typeof pattern === 'string') {
            if (pattern.trim() === '') continue;
            try {
                // Case-insensitive SUBSTRING match for strings
                if (new RegExp(pattern, 'i').test(text)) {
                    return true;
                }
            } catch (e)
            {
                console.warn(`Invalid regex string in matchPattern: "${pattern}" for text "${text}"`, e);
            }
        } else if (pattern instanceof RegExp) {
            // Uses RegExp's own definition (e.g., /pattern/i for case-insensitivity, ^...$ for exactness)
            if (pattern.test(text)) {
                return true;
            }
        } else {
            // console.warn(`Unsupported pattern type in matchPattern: ${typeof pattern}`);
        }
    }
    return false;
};



export const getCategoryAndSubcategory = (
    originalObjectName,
    objectType, 
    categoryPatterns
) => {
    
    if (categoryPatterns && typeof categoryPatterns === 'object') {
        for (const [catKey, patternsOrSubcats] of Object.entries(categoryPatterns)) {
            if (typeof patternsOrSubcats === 'object' && !Array.isArray(patternsOrSubcats) && patternsOrSubcats !== null) {
                // Category with subcategories
                for (const [subKey, patterns] of Object.entries(patternsOrSubcats)) {
                    if (matchPattern(patterns, originalObjectName)) {
                        return { category: catKey, subcategory: subKey, displayName: originalObjectName };
                    }
                }
            } else if (matchPattern(patternsOrSubcats, originalObjectName)) {
                
                return { category: catKey, subcategory: null, displayName: originalObjectName };
            }
        }
    }

   
    const lowerObjectName = originalObjectName.toLowerCase();
    const foundInKeepList = ITEMS_TO_KEEP_IN_MISCELLANEOUS.some(
        keepName => keepName.toLowerCase() === lowerObjectName
    );

    if (foundInKeepList) {
   
        return { category: 'Miscellaneous', subcategory: 'Props', displayName: originalObjectName };
    } else {
        // Item would go to Miscellaneous, but its exact name is NOT on the "keep" list. Filter it out.
        // console.log(`[Categorizer DEBUG] FILTERING (was Misc, not on exact keep list): "${originalObjectName}"`);
        return null;
    }
};